import { ConductorOneChildActive, Router } from "@frui.ts/screens";
import { computed } from "mobx";
import { Modules } from "config";
import LocalizationService from "services/localizationService";
import type ChargeOrderSearchListViewModel from "./chargeOrderSearchListViewModel";
import PairingByOrderListViewModel from "./pairingByOrder/pairingByOrderListViewModel";
import PairingByPaymentListViewModel from "./pairingByPayment/pairingByPaymentListViewModel";

const navigationName = "payments-pairing";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [PairingByPaymentListViewModel, PairingByOrderListViewModel],
})
export default class PaymentsPairingViewModel extends ConductorOneChildActive<
  PairingByPaymentListViewModel | ChargeOrderSearchListViewModel
> {
  constructor(
    private localizationService: LocalizationService,
    private pairingByPaymentListViewModel: PairingByPaymentListViewModel,
    private pairingByOrderListViewModel: PairingByOrderListViewModel
  ) {
    super();
    this.navigationName = navigationName;

    this.children.push(this.pairingByPaymentListViewModel, this.pairingByOrderListViewModel);
  }

  protected onInitialize(): Promise<any> | void {
    this.tryActivateChild(this.children[0]);
    return super.onInitialize();
  }

  @computed
  get name() {
    return this.translate("name");
  }

  @computed
  get showTabs() {
    return !this.activeChild?.activeChild;
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.finance, `paymentsPairing.${code}`, size);
  }
}
